import {createContext, useState} from "react";

export const ThemeContext = createContext({});

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    "email": "",
    "profile": "",
    "countriesList": [],
    "rol": "",
    "userType": "",
    "language": "",
    "laVatSplitEnable": false,
    "emeaVatSplitEnable": false,
    "testEnviroment": true
  });
  const setEmail = (email) => setTheme(prevTheme => ({...prevTheme, email}));
  const setProfile = (profile) => setTheme(prevTheme => ({...prevTheme, profile}));
  const setCountriesList = (countriesList) => setTheme(prevTheme => ({...prevTheme, countriesList}));
  const setRol = (rol) => setTheme(prevTheme => ({...prevTheme, rol}));
  const setUserType = (userType) => setTheme(prevTheme => ({...prevTheme, userType}));
  const setLanguage = (language) => setTheme(prevTheme => ({...prevTheme, language}));
  const setLaVatSplitEnable = (laVatSplitEnable) => setTheme(prevTheme => ({...prevTheme,laVatSplitEnable}));
  const setEmeaVatSplitEnable = (emeaVatSplitEnable) => setTheme(prevTheme => ({...prevTheme,emeaVatSplitEnable}));
  const setTestEnviroment = (testEnviroment) => setTheme(prevTheme => ({...prevTheme,testEnviroment}));
  return (
    <ThemeContext.Provider value={{theme, setEmail, setProfile, setCountriesList, setRol, setUserType
      , setLanguage
      , setLaVatSplitEnable
      , setEmeaVatSplitEnable
      , setTestEnviroment}}>
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider;